import * as Moment from 'moment-timezone';

export const DATE_FORMAT = "YYYY-MM-DD";
export const TIME_FORMAT = "HH:mm";

export function getLabel(duration: number) {
  const dur = Moment.duration(duration);
  const d = dur.get('days');
  const h = dur.get('hours');
  const m = dur.get('minutes');
  const s = dur.get('seconds');
  let ret = "";
  if (d > 0) {
    ret += d + " d"
  }
  if (h > 0) {
    ret += ` ${h} h`
  }
  if (m > 0) {
    ret += ` ${m} m`
  }
  if (s > 0) {
    ret += ` ${s} s`
  }
  return ret;
}

export function formatTimerCode(code?: number) {
  if (!code || code.toString().length !== 6) {
    throw new Error("invalid timer code");
  }
  const str = code.toString();
  return str.substr(0, 3) + " " + str.substr(3);
}

export function generateMyTimerCode() {
  const min = 100_000;
  const max = 1_000_000;
  return Math.floor(Math.random() * (max - min)) + min;
}

export let refreshClockDiff: () => Promise<number> = () => Promise.reject();

export function setRefreshClockDiff(func: () => Promise<number>) {
  refreshClockDiff = func;
}

export async function correctTime(startedMs: number) {
  try {
    const diffSec = await refreshClockDiff();
    return startedMs - diffSec*1000;
  } catch (e) {
    return startedMs;
  }
}

export async function uncorrectTime(startedMs: number) {
  try {
    const diffSec = await refreshClockDiff();
    return startedMs + diffSec*1000;
  } catch (e) {
    return startedMs;
  }
}

export function getNowLocal() {
  return new Date().getTime();
}


// WEBPACK FOOTER //
// ./src/Utils.ts